<div class="time-picker__time-picker-container">
    <div class="time-picker__time-picker-block">
        <button class="common-button__icon-sm-noborder"
            (click)="incrementOrDecrement('hours', 'increment')">
            <i class="lf-icon-angle-up common-icon__md"></i>
        </button>
        <input class="time-picker__time-input"
          [id]="'time-picker-hours-' + timePicker.id"
          [(ngModel)]="timePicker.hoursPicker"
          [pKeyFilter]="'int'"
          placeholder="00"
          maxlength="2"
          autocomplete="off"
          (keyup)="changeInField('hours', $event)"
          (blur)="blurInputTime('hours')"/>
        <button class="common-button__icon-sm-noborder"
            (click)="incrementOrDecrement('hours', 'decrement')">
            <i class="lf-icon-angle-down common-icon__md"></i>
        </button>
    </div>
    <div class="time-picker__time-separator">:</div>
    <div class="time-picker__time-picker-block">
        <button class="common-button__icon-sm-noborder"
            (click)="incrementOrDecrement('minutes', 'increment')">
            <i class="lf-icon-angle-up common-icon__md"></i>
        </button>
        <input class="time-picker__time-input"
          [id]="'time-picker-minutes-' + timePicker.id"
          [(ngModel)]="timePicker.minutesPicker"
          [pKeyFilter]="'int'"
          placeholder="00"
          maxlength="2"
          autocomplete="off"
          (keyup)="changeInField('minutes', $event)"
          (blur)="blurInputTime('minutes')"/>
        <button class="common-button__icon-sm-noborder"
            (click)="incrementOrDecrement('minutes', 'decrement')">
            <i class="lf-icon-angle-down common-icon__md"></i>
        </button>
    </div>
</div>
